import {map, size} from 'lodash';
import {orderBy} from 'natural-orderby';

import ApproveAndDiffButtons from 'components/Button/ApproveAndDiff';
import EditButton from 'components/Button/Edit';
import HistoryTable from 'components/History/Table';
import EditControls from 'components/edit/EditControls';
import ResourceLink from 'components/links/Resource';
import Fact from 'components/shared/fact';
import FactSection from 'components/shared/fact_section';
import RelatedGenesFact from 'pages/Allele/OverviewTab/RelatedGenesFact';

export default function AlleleOverviewTab({allele, haplotypes = [], variant}) {
  const {definitions, geneFunctions = [], relatedGenes = []} = allele;

  return (
    <div className="overviewTab">
      <EditControls>
        <EditButton href={`/edit/allele/${allele.id}`} />
        <ApproveAndDiffButtons objCls="Allele" objId={allele.id} iconOnly={false} />
      </EditControls>
      
      <FactSection title="Associations">
        <RelatedGenesFact genes={orderBy(relatedGenes, (g) => g.symbol)} />
        <Fact label="Associated Reference SNP">
          {variant && <ResourceLink resource={variant} />}
        </Fact>
        <Fact label="Associated Haplotypes">
          {size(haplotypes) > 0 && (
            <ul>
              {map(haplotypes, (h) => <li key={h.accessionId}><ResourceLink resource={h} /></li>)}
            </ul>
          )}
        </Fact>
      </FactSection>

      <FactSection title="Definitions">
        {definitions.map((def, i) => (
          <Fact key={def.id} label={def.assembly || 'Gene'} contentClasses="fixed-width-font">
            {def.name}
          </Fact>
        ))}
      </FactSection>

      {size(geneFunctions) > 0 && (
        <FactSection title="Gene Function" notAvailableWhenEmpty={false}>
          {map(geneFunctions, (f) => (
            <Fact key={f.id} label={`${f.source} Function Assignment`}>
              {f.name}
            </Fact>
          ))}
        </FactSection>
      )}

      <FactSection title="History">
        <HistoryTable parentCls="Allele" parentId={allele.id} history={allele.history} />
      </FactSection>
    </div>
  );
}
